import { z } from 'zod';
// -----------------------------------------------------------------------
// Reminder record
// -----------------------------------------------------------------------
// Snake_case keys mirror the DB columns directly — the bell-icon UI is
// the only consumer for now and there's no aggregation layer in between.
export const ReminderSchema = z.object({
    id: z.number().int(),
    unit_id: z.number().int().nullable(),
    landlord_id: z.number().int().nullable(),
    user_id: z.number().int(),
    body: z.string().nullable(),
    due_at: z.string().datetime(),
    read_at: z.string().datetime().nullable(),
    done_at: z.string().datetime().nullable(),
    created_at: z.string().datetime(),
});
// -----------------------------------------------------------------------
// POST body — used for the unit-scoped create endpoint. unit_id /
// landlord_id are kept optional in the schema for future surfaces
// (e.g. a landlord-level "remind me about this person" action) but the
// /api/units/:id/reminders route ignores them and uses the URL param.
// -----------------------------------------------------------------------
export const CreateReminderSchema = z.object({
    body: z.string().min(1).max(2000).nullable().optional(),
    due_at: z.string().datetime(),
    unit_id: z.number().int().positive().optional(),
    landlord_id: z.number().int().positive().optional(),
});
// -----------------------------------------------------------------------
// PATCH body
// -----------------------------------------------------------------------
export const PatchReminderSchema = z
    .object({
    read_at: z.string().datetime().nullable().optional(),
    done_at: z.string().datetime().nullable().optional(),
})
    .refine((d) => Object.keys(d).length > 0, { message: 'At least one field required' });
// -----------------------------------------------------------------------
// Query params for GET /api/reminders
// -----------------------------------------------------------------------
export const ReminderListQuerySchema = z.object({
    status: z.enum(['unread', 'done', 'all']).default('unread'),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=reminder.js.map